import { createReducer, Action, on } from '@ngrx/store';

import { DocumentViewerActions } from './document-viewer.actions';
import { DocumentViewerState, DocumentViewerViewMode } from './document-viewer.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: DocumentViewerState = {
  xRayOptions: [],
  showClippings: false,
  viewMode: DocumentViewerViewMode.Viewer,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(DocumentViewerActions.ResetViewer, (state, action): DocumentViewerState => initialState),
    on(
      DocumentViewerActions.SetLink,
      (state, action): DocumentViewerState => ({
        ...state,
        link: action.link,
        documentTransactionLibraryId: action.documentTransactionLibraryId,
        documentId: action.documentId,
        viewMode: DocumentViewerViewMode.Viewer,
        originalSignedUrl: undefined,
        originalTitle: undefined,
      })
    ),
    on(
      DocumentViewerActions.SetXRayOptions,
      (state, action): DocumentViewerState => ({ ...state, xRayOptions: action.options })
    ),
    on(
      DocumentViewerActions.SetClippings,
      (state, action): DocumentViewerState => ({ ...state, showClippings: action.showClippings })
    ),
    on(
      DocumentViewerActions.SetCustomUrl,
      (state, action): DocumentViewerState => ({
        ...state,
        originalSignedUrl: action.url,
        originalTitle: action.customTitle,
        customFormat: action.customFormat,
      })
    ),
    on(
      DocumentViewerActions.SetViewMode,
      (state, action): DocumentViewerState => ({ ...state, viewMode: action.viewMode })
    ),
    on(
      DocumentViewerActions.SetCommentsEnabled,
      (state, action): DocumentViewerState => ({ ...state, commentsEnabled: action.enabled })
    )
  )
);

export function reducer(state: DocumentViewerState | undefined, action: Action) {
  return featureReducer(state, action);
}
